"use client"

import { useEffect, useState } from "react"

export function ResponsiveFontSizeController() {
	const [screenWidth, setScreenWidth] = useState(0)

	useEffect(() => {
		const updateFontSize = () => {
			const currentWidth = window.innerWidth
			setScreenWidth(currentWidth)

			// 移动端断点（小于768px，对应Tailwind的md断点）
			if (currentWidth < 768) {
				// 移动端：根据屏幕宽度动态计算font-size，基准375px = 16px
				const baseFontSize = Math.max(
					12,
					Math.min(32, (currentWidth / 375) * 16),
				)
				document.documentElement.style.fontSize = `${baseFontSize}px`
			} else {
				// 桌面端：根据屏幕宽度动态计算font-size，基准1920px = 16px，最大16px，超过1920px 不变化
				const baseFontSize = Math.max(
					14,
					Math.min(16, (currentWidth / 1920) * 16),
				)
				document.documentElement.style.fontSize = `${baseFontSize}px`
			}
		}

		// 初始设置
		updateFontSize()

		// 监听屏幕尺寸变化
		window.addEventListener("resize", updateFontSize)

		// 清理事件监听器
		return () => {
			window.removeEventListener("resize", updateFontSize)
		}
	}, [])

	return (
		<div
			style={{
				display: "none",
				position: "fixed",
				top: 0,
				left: 0,
				zIndex: 9999,
				background: "rgba(0,0,0,0.8)",
				color: "white",
				padding: "4px 8px",
				fontSize: "12px",
			}}
		>
			Screen Width: {screenWidth}px
		</div>
	)
}
